export const SEARCH_WIDGET = {
  ACTION_TYPES: {
    changeQueryHandler: 'changeQueryHandler',
    entityClickHandler: 'entityClickHandler',
    itemHoverHandler: 'itemHoverHandler',
    onKeyboardPressHandler: 'onKeyboardPressHandler',
    onSearchClearHandler: 'onSearchClearHandler',
    openMenuHandler: 'openMenuHandler',
    toggleExpandedHandler : 'toggleExpandedHandler',
    sportTypePopulateData : 'sportTypePopulateData',
    fetchSportTypes: 'fetchSportTypes',
    sportTypeClick: 'sportTypeClick',
    storageEntity: 'storageEntity'
  },

  ANALYTICS: {
    ACTION_TYPES: {
      onSearchClickEvent: 'onSearchClickEvent',
      onSportTypesClick: 'onSportTypesClick',
      onSearchEnded: 'onSearchEnded'
    },

    SOURCES: {
      header: 'search-header',
      mobileHeader: 'search-mobile-header',
      footer: 'search-footer',
      catalog: 'catalog',
      noAthlete: 'search-no-athlete',
    },

    RESULT_TYPE: {
      starClick: 2,
      entityClick: 1,
      other: 0
    },

    STOP_TYPING_DELAY: 3000,

    SUB_SOURCE: {
      popular: "popular",
      popularAll: "popular-all"
    },

    SCREEN: {
      recent: "recent",
      popularTeams: "popular-teams",
      popularLeagues: "popular-leagues",
      popularAthletes: "popular-athletes"
    }
  },

  ALL_SPORTS_ID: -1,
  ICON_SIZE: 18,
};
